import React, { useEffect } from "react";
import { CustomForm, CustomInput } from "../../shared/Input/AllInputs";
import { CustomPhoneNumber } from "../../shared/Input/CustomPhoneInput";
import CustomImageInput from "../../shared/Input/CustomImageInput";
import PrimaryButton from "../../shared/Button/PrimaryButton";
import UserContainer from "./UserContainer";

const UserForm = ({ type }) => {
    const { data, handleChange, loading, onSubmit, setFormType } = UserContainer();

    useEffect(() => {
        setFormType(type);
    }, [type, setFormType]);

    return (
        <CustomForm style={type === "VIEW" ? { pointerEvents: "none" } : {}}>
            <CustomImageInput name="image" label="User Image" key="image" data={data} editable={true} onFilesChange={handleChange} />
            <CustomInput label="Full Name" name="fullName" data={data} onChange={handleChange} />
            <CustomInput label="Email Address" name="email" data={data} disabled />
            <CustomPhoneNumber label="Mobile Number" value={data?.countryCode + data?.mobile} disabled />
            {type !== "VIEW" && <PrimaryButton label="Save User" loading={loading} onClick={onSubmit} col={6} />}
        </CustomForm>
    );
};

export default UserForm;
